module.exports = "<div id=pickupTable class=q-overflow-x-auto> <div class=\"q-overflow-x-hidden q-min-width-sm\"> <table class=\"table q-table q-table-vert-middle q-no-marg q-table-min-height q-table-pad-tds-md\"> <thead> <tr> <th>Pickup Date</th> <th class=q-text-right>Estimated Time</th> <th class=q-text-right>Estimated Cost</th> </tr> </thead> <tbody id=quoteResponse> <tr> <td>{%- pickUpDate %}</td> <td class=q-text-right>{%- transit %} days</td> <td class=q-text-right>{%- quote %}</td> </tr> </tbody> </table> </div> </div>";


//////////////////
// WEBPACK FOOTER
// ./src/pages/amazon-fba-order/html/QuoteResponse.html
// module id = 278
// module chunks = 1